import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { ServiceTypes } from '@pharmaplan/common';
import ServiceHandler from '@pharmaplan/common/helpers/ServiceHandler';
import strings from '../../../../localization';

import classes from './styles';

const { self, full } = ServiceTypes;

export enum InfoNotesType {
  applicableTaxes,
  onlyPharmaGapFees,
}

interface IInfoNote {
  type: InfoNotesType;
}

const InfoNote: FC<IInfoNote> = ({ type }) => {
  const serviceBasedLabels = {
    [self]: strings.pharmagapFeesWithApplicableTax,
    [full]: strings.onlyPharmaGapFeesWillBeCharged,
  };

  const label = {
    [InfoNotesType.applicableTaxes]: strings.applicableTaxes,
    [InfoNotesType.onlyPharmaGapFees]:
      serviceBasedLabels[ServiceHandler.getService()],
  };

  return (
    <Box sx={classes.container}>
      <Typography sx={classes.infoText}>{label[type]}</Typography>
    </Box>
  );
};

export default InfoNote;
